import { createSlice } from '@reduxjs/toolkit';

export const mockImagesSlice = createSlice({
	name: 'mockImages',
	initialState: {
		value: {
			shelf: null,
			product: null,
		},
	},
	reducers: {
		setMockImages: (state, action) => {
			state.value = action.payload;
		},
		setMockShelf: (state, action) => {
			state.value = { shelf: action.payload, product: state.value.product };
		},
		setMockProduct: (state, action) => {
			state.value = { product: action.payload, shelf: state.value.shelf };
		},
	},
});

// Action creators are generated for each case reducer function
export const { setMockImages, setMockShelf, setMockProduct } = mockImagesSlice.actions;
export const selectMockImages = (state) => state.mockImages.value;
export default mockImagesSlice.reducer;
